var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},[_c('div',{staticClass:"gc-input-radio-button-squared__circle"}),_c('icon-tick',{attrs:{"size":'sm1'}}),_c('icon-dislike',{attrs:{"size":'sm1'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }